<template>
  <public-layout>
    <section class="hero lvl2">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">
            <div class="column">
              <p class="product-title">
                Seminars
              </p>
              <p class="product-subtitle">
                Empowering you to co-design a better future for your students!
              </p>
              <p class="product-description">
                Offers opportunity to study key concept of Fun Learning through on-site visits, workshops and global networking.
                 Encourages participants to reflect on the differences, successes and drawbacks in global education.
                  Prompts them to focus on their personal strengths and weaknesses, and develop their pedagogy.
              </p>
              <p class="product-cta">
                <Button :to="{ name: 'contact' }" size="large">Contact Us</Button>
                <router-link class="button button-large button-secondary" :to="{ name: 'prof-dev' }">Go Back</router-link>
              </p>
            </div>
            <div class="column is-narrow">
              <img class="product-image" src="/static/img/assets/seminars-big.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>

    <hr>

    <section class="section course-info is-left-aligned">
      <div class="container  has-text-centered">
        <div class="columns">

          <div class="column is-12">
            <h3>Introducing you to the world of Fun Learning</h3>
            <div class="content content-centered">
              <p>Through Fun Academy Seminars participants will be able to</p>
              <img class="info-seminars" src="static/img/assets/seminars-infography.jpg" alt="Image">
            </div>
          </div>
        </div>
      </div>
    </section>

  </public-layout>
</template>

<script>
import PublicLayout from '@/layouts/PublicLayout'
import SectionContact from '@/components/SectionContact'
import Button from '@/components/Button'

export default {
  name: 'kinderpage',

  components: {
    PublicLayout,
    SectionContact,
    Button
  },

  created () {},

  data () {
    return {}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.section h3 {
    font-size: 1.5em;
    margin-bottom: 0.6666em;
}
.product-cta{
  margin-top: 1.5rem;
}

.product-image{
  width: 480px;
  height: 320px;
}
.section .content.content-centered {
  display: inline-block;
  text-align: left;
}

.info-seminars {
  max-width: 430px;
}
</style>



// WEBPACK FOOTER //
// src/pages/SeminarsPage.vue